import styled from 'styled-components';

export const Loader = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const GoSafeLoader = styled.div`
  border-radius: 1.2rem;
  overflow: hidden;
`;
export const HomeCarousel = styled.div`
  border-radius: 1.2rem;
  overflow: hidden;
`;
export const RecentSearchLoader = styled.div`
  display: flex;
  flex-direction: row;
`;
export const LoaderColumn = styled.div`
  width: 48.2rem;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 1.2rem;
  overflow: hidden;
  &:first-child {
    margin-right: 1rem;
  }
  div {
    padding: 1rem;
  }
`;
